import { connect } from 'react-redux';
import CloseIcon from './CloseIcon';

export default connect(
  ({ settings: { style = {} } }) => ({
    style,
  }),
)(CloseIcon);
